import styled from 'styled-components';

export const Button = styled.button`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  background: #fafafa;
  border-radius: 4px;
  border: 1px dashed #d9d9d9;

  &:before {
    display: block;
    padding-bottom: 100%;
    content: '';
  }

  svg {
    color: ${({ theme }) => theme.brand.primary.base};
  }
`;
